import { OrderResponseDTOOrderStatusEnum } from '@sellsen/generated-sources';

export const ORDER_STATUS_TAG: Partial<
  Record<OrderResponseDTOOrderStatusEnum, string>
> = {
  [OrderResponseDTOOrderStatusEnum.PendingAvailability]: 'default',
  [OrderResponseDTOOrderStatusEnum.Pending]: 'processing',
  [OrderResponseDTOOrderStatusEnum.Unshipped]: 'warning',
  [OrderResponseDTOOrderStatusEnum.PartiallyShipped]: 'cyan',
  [OrderResponseDTOOrderStatusEnum.Shipped]: 'blue',
  [OrderResponseDTOOrderStatusEnum.InvoiceUnconfirmed]: 'geekblue',
  [OrderResponseDTOOrderStatusEnum.Cancelled]: 'error',
  [OrderResponseDTOOrderStatusEnum.Unfulfillable]: 'magenta',
};

export const ORDER_STATUS_LABEL_TR: Record<
  OrderResponseDTOOrderStatusEnum,
  string
> = {
  [OrderResponseDTOOrderStatusEnum.PendingAvailability]:
    'Müsaitlik bekleniyor',
  [OrderResponseDTOOrderStatusEnum.Pending]: 'Beklemede',
  [OrderResponseDTOOrderStatusEnum.Unshipped]: 'Kargolanmadı',
  [OrderResponseDTOOrderStatusEnum.PartiallyShipped]: 'Kısmen kargolandı',
  [OrderResponseDTOOrderStatusEnum.Shipped]: 'Kargolandı',
  [OrderResponseDTOOrderStatusEnum.InvoiceUnconfirmed]: 'Fatura onayı bekliyor',
  [OrderResponseDTOOrderStatusEnum.Cancelled]: 'İptal edildi',
  [OrderResponseDTOOrderStatusEnum.Unfulfillable]: 'Karşılanamıyor',
};

export const formatOrderStatusLabel = (status: string) =>
  ORDER_STATUS_LABEL_TR[status as OrderResponseDTOOrderStatusEnum] ??
  status.replace(/_/g, ' ');

const CANCELLATION_REQUESTER_TR: Record<string, string> = {
  BUYER: 'Müşteri',
  MERCHANT: 'Satıcı',
  AMAZON: 'Amazon',
};

const CANCELLATION_REASON_TR: Record<string, string> = {
  'Buyer requested cancellation': 'Müşteri iptal istedi',
  ShippingAddressUndeliverable: 'Teslimat adresine ulaşılamıyor',
  ORDER_WAS_CREATED_BY_MISTAKE: 'Sipariş yanlışlıkla oluşturuldu',
  ITEMS_WOULD_ARRIVE_TOO_LATE: 'Ürünler çok geç varacak',
  OTHER_REASON: 'Diğer sebep',
  REASON_LEFT_UNSPECIFIED: 'Sebep belirtilmedi',
};

export const formatCancellationRequester = (requester: string) =>
  CANCELLATION_REQUESTER_TR[requester] ?? requester;

export const formatCancellationReason = (reason: string) =>
  CANCELLATION_REASON_TR[reason] ?? reason;

/** İptal etiketinin tooltip satırları. İkisi de boşsa tooltip yok. */
export const cancellationTooltipLines = (order: {
  orderStatus?: string;
  cancellationRequestedBy?: string;
  cancellationReason?: string;
}): string[] => {
  if (order.orderStatus !== OrderResponseDTOOrderStatusEnum.Cancelled) {
    return [];
  }
  const lines: string[] = [];
  if (order.cancellationRequestedBy) {
    lines.push(
      `İsteyen: ${formatCancellationRequester(order.cancellationRequestedBy)}`
    );
  }
  if (order.cancellationReason) {
    lines.push(formatCancellationReason(order.cancellationReason));
  }
  return lines;
};

/**
 * Sipariş durumu Amazon'dan gelir; kullanıcı değiştiremez. Bu liste yalnız filtreleme içindir.
 * Teslim edildi bilgisi siparişte değil paket durumundadır (PACKAGE_STATUS_LABEL_TR).
 */
export const ORDER_STATUS_OPTIONS = Object.values(
  OrderResponseDTOOrderStatusEnum
).map((value) => ({
  value,
  label: formatOrderStatusLabel(value),
}));
